import { isJwtExpired } from 'jwt-check-expiration';
import Config from '../../config';
import LocalData from '../../helpers/LocalData';
import {checkAuthTokenUseCase} from '../../helpers/auth-token.js';

class Auth {
    login(cb) {
        if (LocalData.get(Config.LOCAL_DATA_KEYS.JWT_ACCESS_TOKEN)) {
            cb();
        }
    }
    logout(cb) {
        LocalData.remove(Config.LOCAL_DATA_KEYS.JWT_ACCESS_TOKEN);
        LocalData.remove(Config.LOCAL_DATA_KEYS.ACCESS_TOKEN);
        // localStorage.clear();
        cb();
    }
    isAuthenticated() {
        return checkAuthTokenUseCase();
    }
}

export default new Auth();
